import { ChosenOptionAnswer } from '../../components/context/SurveyPageContext';

interface BuildChosenOptionAnswer {
  questionId: number;
  optionId: number;
}

const buildChosenOptionAnswer = ({
  questionId,
  optionId,
}: BuildChosenOptionAnswer): ChosenOptionAnswer => ({
  question: { id: questionId },
  chosenOption: { id: optionId },
});

export { buildChosenOptionAnswer };
